import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class SendPaymentInstructionService {
  api: string;
  receipient: string;
  clientEmail: string;
  tradeList: string;
  ultimateRemitter: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl + `/payment`;
    this.receipient = environment.customerApiUrl + `/receipient`;
    this.tradeList = environment.customerApiUrl + `/trade`;
    this.ultimateRemitter = environment.customerApiUrl + `/ultimateRemitter`;
  }

  /**
   * @method getSearchData
   * @description get data for search in screen 1
   */
  public getSearchData(param): Observable<any> {
    return this.http.post(`${this.receipient}/receipient-list`, param);
  }

  /**
   * @method getReasonPaymentData
   * @description get data for reason payment screen 1
   */
  /**
   * @method getPaymentInstructionData
   * @description get data for screen 2
   */
  public getPaymentInstructionData(params): Observable<any> {
    return this.http.post(`${this.tradeList}/trade-list`, params);
  }

  public getPaymentBankName(param): Observable<any> {
    return this.http.post(`${this.receipient}/bank-detail-payment`, param);
  }

  public insertClientPayment(paymentBody: any): Observable<any> {
    return this.http.post(`${this.api}/insert-client-payment-instruction`, paymentBody);
  }

  public checkBalanceByCurrency(currencyId: string, buyAmount: number): Observable<any> {
    return this.http.get(`${this.tradeList}/check-balance-currency/${currencyId}/${buyAmount}`, <Object>{
      responseType: 'text'
    });
  }
  public downloadPDFConfirmation(paymentBody: any): Observable<any> {
    return this.http.post(`${this.tradeList}/show-payment-instruction-pdf`, paymentBody, { responseType: 'blob' });
  }

  public getBalanceAmount(param): Observable<any> {
    return this.http.post(`${this.tradeList}/my-currency-available-balance`, param);
  }

  public sendPasscode(param): Observable<any> {
    return this.http.post(`${this.api}/payment-twilio-verification`, param);
  }

  public getPaymentCodes(countryId): Observable<any> {
    return this.http.get(`${this.api}/get-purpose-of-payment-codes/${countryId}`);
  }

  public getPaymentCodesForCNY(): Observable<any> {
    return this.http.get(`${this.api}/get-purpose-of-payment-codes-for-cny`);
  }

  public sendPaymentCode(param): Observable<any> {
    return this.http.post(`${environment.identityApiUrl}/account/send-payment-verification-code`, param);
  }

  public getAllBalancesAndAvailableCurrencies(param): Observable<any> {
    return this.http.post(`${this.tradeList}/all-balances-with-available-currencies`, param);
  }

  public getBalanceBreakdownForCurrency(param): Observable<any> {
    return this.http.post(`${this.tradeList}/all-balances-with-available-currencies`, param);
  }

  public validateBeneficiary(id): Observable<any> {
    return this.http.get(`${this.receipient}/validate-recipient/${id}`);
  }

  // Get ultimate remitters of a particular account
  public getUltimateRemitters(param): Observable<any> {
    return this.http.post(`${this.ultimateRemitter}/get-ultimate-remitters`, param);
  }

  // Insert an ultimate remitter
  public insertUltimateRemitter(param): Observable<any> {
    return this.http.post(`${this.ultimateRemitter}/insert-ultimate-remitter`, param);
  }

  public checkCurrencyIsInTradingDay(param): Observable<any> {
    return this.http.post(`${this.api}/check-currency-is-in-trading-day`, param);
  }

  public updateBankSEPA(param): Observable<any> {
    return this.http.post(`${this.api}/update-bank-sepa`, param);
  }
}
